import { translationMessages } from 'config/translations';
import { createIntl, createIntlCache } from 'react-intl';

const locale = 'en';
const messages = translationMessages[locale];
const cache = createIntlCache();

export const intl = createIntl(
  {
    locale,
    messages,
    onError: (err) => {
      if (err.code === 'MISSING_TRANSLATION') {
        console.warn('Missing translation', err.message);
        return;
      }
      throw err;
    },
  },
  cache
);
